module.exports = __webpack_public_path__ + "img/penalties-image.c6cece59.svg";